import { TrainingDoctype } from '..';
import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type UnacknowledgedSignoffResponse = {
   signoff_requestid: number;
   course: {
      wikiid: number;
      title: string;
   };
   courseStage: {
      doctype: TrainingDoctype;
      docid: number;
      title: string;
   };
   requestor: {
      userid: number;
      username: string;
      userAvatar: string;
      userProfile: string;
   };
   requestee: {
      userid: number;
      username: string;
      userAvatar: string;
      userProfile: string;
   };
   work_log_entryid: null | number;
   response_value: number;
   response_feedback: string;
   created_at: number;
   completed_at: number;
};

export type GetUnacknowledgedSighoffResponsesResponse = {
   hasMore: boolean;
   signoffResponses: UnacknowledgedSignoffResponse[];
};

export type GetUnacknowledgedSignoffResponsesOptions = CommonRequestOptions & {
   offset?: number;
   limit?: number;
   courseid?: number;
};

export async function getUnacknowledgedSignoffResponses(
   userid: number,
   { limit, offset, courseid, ...common }: GetUnacknowledgedSignoffResponsesOptions = {}
): Promise<GetUnacknowledgedSighoffResponsesResponse> {
   let url = `/courses/stage-sign-offs/responses/unacknowledged/${userid}`;

   return makeRequest('get', url, {
      query: {
         limit,
         offset,
         courseid,
      },
      ...common,
   });
}
